import React, { useState } from "react";

export default function LifeHackCalc() {
  const [dailyExpense, setDailyExpense] = useState("");
  const [coffeeCost, setCoffeeCost] = useState("");
  const [hoursPerDay, setHoursPerDay] = useState("");
  const [sleepHours, setSleepHours] = useState("");

  return (
    <div className="min-h-screen bg-black text-white p-4 space-y-6">
      <h1 className="text-xl font-bold text-center">🧠 LifeHack Calculator</h1>

      {/* Daily Expense */}
      <div className="bg-gray-900 p-4 rounded-2xl">
        <h2 className="text-lg mb-2">💰 Daily Expense Reality</h2>
        <input
          type="number"
          placeholder="Enter daily spend ₹"
          value={dailyExpense}
          onChange={(e) => setDailyExpense(e.target.value)}
          className="w-full p-2 rounded bg-black border border-gray-700"
        />
        {dailyExpense && (
          <div className="mt-2 text-sm space-y-1">
            <p>Monthly: ₹ {dailyExpense * 30}</p>
            <p>Yearly: ₹ {dailyExpense * 365}</p>
          </div>
        )}
      </div>

      {/* Coffee Hack */}
      <div className="bg-gray-900 p-4 rounded-2xl">
        <h2 className="text-lg mb-2">☕ Coffee Cost</h2>
        <input
          type="number"
          placeholder="Cost per coffee ₹"
          value={coffeeCost}
          onChange={(e) => setCoffeeCost(e.target.value)}
          className="w-full p-2 rounded bg-black border border-gray-700"
        />
        {coffeeCost && (
          <div className="mt-2 text-sm space-y-1">
            <p>Monthly: ₹ {coffeeCost * 30}</p>
            <p>Yearly: ₹ {coffeeCost * 365}</p>
            <p className="text-red-400">
              10 Years: ₹ {coffeeCost * 365 * 10}
            </p>
          </div>
        )}
      </div>

      {/* Time Value */}
      <div className="bg-gray-900 p-4 rounded-2xl">
        <h2 className="text-lg mb-2">⏳ Time Value</h2>
        <input
          type="number"
          placeholder="Hours wasted/day"
          value={hoursPerDay}
          onChange={(e) => setHoursPerDay(e.target.value)}
          className="w-full p-2 rounded bg-black border border-gray-700"
        />
        {hoursPerDay && (
          <div className="mt-2 text-sm space-y-1">
            <p>Yearly: {hoursPerDay * 365} hrs</p>
            <p className="text-red-400">
              Lifetime (30 yrs): {hoursPerDay * 365 * 30} hrs
            </p>
          </div>
        )}
      </div>

      {/* Sleep Tracker */}
      <div className="bg-gray-900 p-4 rounded-2xl">
        <h2 className="text-lg mb-2">💤 Sleep Life</h2>
        <input
          type="number"
          placeholder="Sleep hrs/day"
          value={sleepHours}
          onChange={(e) => setSleepHours(e.target.value)}
          className="w-full p-2 rounded bg-black border border-gray-700"
        />
        {sleepHours && (
          <div className="mt-2 text-sm space-y-1">
            <p>Yearly: {sleepHours * 365} hrs</p>
            <p>
              Life (80 yrs): {sleepHours * 365 * 80} hrs (~
              {((sleepHours * 365 * 80) / (24 * 365)).toFixed(1)} years)
            </p>
          </div>
        )}
      </div>

      {/* Savings Growth */}
      <div className="bg-gray-900 p-4 rounded-2xl">
        <h2 className="text-lg mb-2">📈 Savings Hack</h2>
        <input
          type="number"
          placeholder="Daily savings ₹"
          onChange={(e) => setDailyExpense(e.target.value)}
          className="w-full p-2 rounded bg-black border border-gray-700"
        />
        {dailyExpense && (
          <div className="mt-2 text-sm space-y-1">
            <p>1 Year: ₹ {dailyExpense * 365}</p>
            <p className="text-green-400">
              5 Years: ₹ {dailyExpense * 365 * 5}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}